<div style="display: flex" (click)="callToAction()" [attr.middle-click]="url">
  <nz-tag
    *ngIf="config"
    [nzColor]="config.color"
    class="!inline-flex !items-center !justify-center !m-0 !h-6 !w-6 !text-[12px] !p-0 !text-center"
    [ngStyle]="{ color: config.textColor }"
    nz-tooltip
    [nzTooltipTitle]="allowTooltip ? config.tooltip : ''"
  >
    <nz-icon [nzType]="config.icon" nzTheme="outline" />
  </nz-tag>
</div>
